import CDRTable from '@/components/cdr/CDRTable';

export default function CDRViewer() {
  return (
    <div className="space-y-6 animate-fade-in-up">
      <div>
        <h1 className="text-3xl font-bold tracking-tight bg-gradient-to-r from-blue-400 to-purple-500 bg-clip-text text-transparent">
          CDR Viewer
        </h1>
        <p className="text-muted-foreground mt-1">
          Registro dettagliato delle chiamate con trunk, destinazione interna e qualità
        </p>
      </div>
      <CDRTable
        showFilters={true}
        showExport={true}
        showBackfill={true}
      />
    </div>
  );
}
